import { disputeSource } from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const updateDisputeEvidence = {
  name: "updateDisputeEvidence" as const,
  input: z.object({
    disputeId: z.string(),
    source: z.enum(disputeSource),
    accessActivityLog: z.string().optional(),
    customerCommunicationFileUrl: z.string().optional(),
    invalidDisputeReason: z.string().optional(),
    uncategorizedFileUrl: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
